import React, { useState, useEffect, useRef } from "react";
import Barcode from "react-barcode";
import { QRCodeCanvas } from "qrcode.react";
import { getAllProducts } from "../../../Utility/Api";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { NaviGate } from "../../../Utility/function";
const BarCodeScreen = () => {
  const [productsData, setProductsData] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [barcodeType, setBarcodeType] = useState("Barcode");
  const [barcodeSource, setBarcodeSource] = useState("barcode");
  const [showProductCode, setshowProductCode] = useState('true');
  const [unitType, setUnitType] = useState("mm");
  const [paperWidth, setPaperWidth] = useState(70);
  const [paperHeight, setPaperHeight] = useState(100);
  const [printQuantity, setPrintQuantity] = useState(1);

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    if (window.PrinterSDK) {
      window.PrinterSDK.getNetworkPrinters()
        .then((printers) => console.log("Printers:", printers))
        .catch((err) => console.error("Error:", err));
    } else {
      console.log("Printer SDK not found");
    }
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await getAllProducts();
      if (response.data?.data) {
        setProductsData(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handlePrint = async (ref, isQRCode) => {
    const content = ref.current;
    if (!content) {
      console.error("Print content not found");
      return;
    }

    try {
      // Remove margins & padding
      content.style.margin = "0";
      content.style.padding = "0";

      const canvas = await html2canvas(content, {
        scale: 2, // Improve print resolution
        backgroundColor: "#fff", // Ensure white background
        useCORS: true,
        letterRendering: true,
      });

      const imgData = canvas.toDataURL("image/png");

      // Convert dimensions to mm
      let widthInMm = unitType === "cm" ? paperWidth * 10 : paperWidth;
      let heightInMm = unitType === "cm" ? paperHeight * 10 : paperHeight;

      // Ensure portrait mode (height > width)
      if (widthInMm > heightInMm) {
        [widthInMm, heightInMm] = [heightInMm, widthInMm]; // Swap values
      }

      const pdf = new jsPDF({
        // orientation: "portrait",
        orientation: "landscape",

        unit: "mm",
        format: [widthInMm, heightInMm],
      });

      for (let i = 0; i < printQuantity; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        pdf.addImage(imgData, "PNG", 0, 0, heightInMm, widthInMm, "", 180);
      }
      pdf.autoPrint();
      window.open(pdf.output("bloburl"), "_blank");
    } catch (error) {
      console.error("Error generating the PDF:", error);
    }
  };

  const barCodeRef = useRef(null);
  const qrCodeRef = useRef(null);
  const bothScanRef = useRef(null);
  const [searchProduct, setSearchProduct] = useState();
  const [SelectedProducts, setSelectedProducts] = useState();
  const [ProductDescription, setProductDescription] = useState();
  const filteredProduct = searchProduct
    ? productsData.filter(
        (item) =>
          item.status != 2 &&
          item.product_name.toLowerCase().includes(searchProduct.toLowerCase())
      )
    : productsData.filter((product) => product.status != 2);

  const handleBarcodeTypeChange = (e) => {
    setUnitType(e.target.value);
  };

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <div className="min-h-screen flex items-center justify-center bg-gray-100 p-6">
          <NaviGate />
          <div className="bg-white shadow-xl rounded p-6 w-full max-w-lg p-4">
            <h2 className="text-xl font-bold text-gray-700 mb-6 text-center">
              Barcode Generator
            </h2>
            <div className="col-12 row">
              <div className="mb-4 col-3 me-5 row pe-4">
                <label className="block text-gray-600 font-medium mb-1 px-0">
                  Select Product
                </label>
                <div className="dropdown w-100 px-0">
                  <input
                    className="w-100 border border-gray-300 p-2 w-full rounded focus:ring focus:ring-blue-300"
                    type="text"
                    placeholder="Search Product"
                    value={searchProduct}
                    onChange={(e) => {
                      setSearchProduct(e.target.value);
                    }}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  />
                  <ul
                    className="dropdown-menu w-100 p-1"
                    style={{ maxHeight: "300px", overflowY: "scroll" }}
                  >
                    {filteredProduct.map((item) => (
                      <div
                        key={item.product_id}
                        className="col-md-12"
                        onClick={() => {
                          setSelectedProduct(item.product_id);
                          setSearchProduct(item.product_name);
                          setSelectedProducts(item.product_name);
                          setProductDescription(item.descriptions);
                        }}
                      >
                        <p className="pointer">{item.product_name}</p>
                      </div>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="mb-4 col-3 row pe-4">
                <label className="block text-gray-600 font-medium mb-1">
                  Paper Width ({unitType}):
                </label>
                <input
                  type="number"
                  value={paperWidth}
                  onChange={(e) => setPaperWidth(parseFloat(e.target.value))}
                  className="border border-gray-300 p-2 w-full rounded focus:ring focus:ring-blue-300"
                  min="1"
                />
              </div>

              <div className="mb-4 col-3 row pe-4">
                <label className="block text-gray-600 font-medium mb-1">
                  barcode Height ({unitType}):
                </label>
                <input
                  type="number"
                  value={paperHeight}
                  onChange={(e) => setPaperHeight(parseFloat(e.target.value))}
                  className="border border-gray-300 p-2 w-full rounded focus:ring focus:ring-blue-300"
                  min="1"
                />
              </div>

              <div className="mb-4 col-3 row pe-4">
                <label className="block text-gray-600 font-medium mb-1">
                  Unit Type:
                </label>
                <select
                  value={unitType}
                  onChange={handleBarcodeTypeChange}
                  className="border border-gray-300 p-2 w-full rounded focus:ring focus:ring-blue-300"
                >
                  <option value="mm">Millimeter (mm)</option>
                  <option value="cm">Centimeter (cm)</option>
                </select>
              </div>

              <div className="mb-4 col-3 row pe-4">
                <label className="block text-gray-600 font-medium mb-1 px-0">
                  Select Code Type
                </label>
                <select
                  value={barcodeType}
                  onChange={(e) => setBarcodeType(e.target.value)}
                  className="border border-gray-300 p-2 w-full rounded focus:ring focus:ring-blue-300"
                >
                  <option value="Barcode">Barcode</option>
                  <option value="QRCode">QR Code</option>
                </select>
              </div>

              <div className="mb-4 col-3 row pe-4">
                <label className="block text-gray-600 font-medium mb-1 px-0">
                  Select Source
                </label>
                <select
                  value={barcodeSource}
                  onChange={(e) => setBarcodeSource(e.target.value)}
                  className="border border-gray-300 p-2 w-full rounded focus:ring focus:ring-blue-300"
                >
                  <option value="barcode">Item Barcode</option>
                  <option value="box_bar_code">Box Barcode</option>
                </select>
              </div>

              <div className="mb-4 col-3 row pe-4">
                <label className="block text-gray-600 font-medium mb-1 px-0">
                  Print Quantity
                </label>
                <input
                  type="number"
                  value={printQuantity}
                  onChange={(e) => {
                    const value = parseInt(e.target.value);
                    setPrintQuantity(value > 0 ? value : 1);
                  }}
                  className="border border-gray-300 p-2 w-full rounded focus:ring focus:ring-blue-300"
                  min="1"
                  step="1"
                  placeholder="Enter quantity"
                />
              </div>
              <div className="mb-4 col-3 row pe-4">
                <label className="block text-gray-600 font-medium mb-1 px-0">
                  Show Product Code
                </label>
                <select
                  value={showProductCode}
                  onChange={(e) => setshowProductCode(e.target.value)}
                  className="border border-gray-300 p-2 w-full rounded focus:ring focus:ring-blue-300"
                >
                  <option value={'true'}>Show</option>
                  <option value={'false'}>None</option>
                </select>
              </div>
              <div className="my-4 d-flex justify-content-center">
                <div
                  className="card shadow"
                  style={{ maxWidth: "650px" }}
                  ref={bothScanRef}
                >
                  <div className="text-center">
                    <h4 className="mb-0 mt-3" style={{ fontSize: "40px" }}>
                      {searchProduct}
                    </h4>
                  </div>
                  {selectedProduct ? (
                    barcodeType === "QRCode" ? (
                      <div className="pt-2 text-center" ref={qrCodeRef}>
                        <QRCodeCanvas
                          value={
                            productsData.find(
                              (p) => p.product_id == selectedProduct
                            )?.[barcodeSource] || "No Value"
                          }
                          width={350}
                          height={350}
                        />
                      </div>
                    ) : (
                        <div className="pt-2 text-center" ref={barCodeRef}>
                          <hr className="m-0" />
                       
                            <Barcode
                              value={
                                productsData.find(
                                  (p) => p.product_id == selectedProduct
                                )?.["barcode"] || "000000000000"
                              }
                              format="CODE128"
                              width={4}
                              height={85}
                              fontSize={38}
                              displayValue={true} // If supported, shows the code below

                            />
                             {showProductCode == 'true' && (
                          <>
                          <hr className="m-0" />
                          <Barcode
                            value={
                              productsData.find(
                                (p) => p.product_id == selectedProduct
                              )?.["product_code"] || "000000000000"
                            }
                            format="CODE128"
                            width={4}
                            height={85}
                            fontSize={38}
                            displayValue={false}
                          />
                          <br />
                          <text style={{ font: "38px monospace", color: "black" }} textAnchor="middle" x="246" y="125">
                            S.NO:{" "}{
                              productsData.find(
                                (p) => p.product_id == selectedProduct
                              )?.["product_code"] || "000000000000"
                            }
                          </text>
                          </>
)}
                        </div>
                    )
                  ) : (
                    <p className="text-gray-400">No product selected</p>
                  )}
                  <div className="text-center">
                   
                    {SelectedProducts && (
                      <h4 className="font-35 mt-2 text-black">
                        <hr className="m-0" />
                        Price -{" "}
                        {barcodeSource === "barcode"
                          ? (Number(
                                productsData.find(
                                  (p) => p.product_id == selectedProduct
                                )?.avg_sales_price
                              ) || 0
                            ).toFixed(3)
                          : (Number(
                                productsData.find(
                                  (p) => p.product_id == selectedProduct
                                )?.avg_box_sales_cost
                              ) || 0
                            ).toFixed(3)}{" "}
                        &nbsp;RO
                      </h4>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <button
              onClick={() =>
                handlePrint(
                  barcodeType === "QRCode" ? bothScanRef : bothScanRef,
                  barcodeType === "QRCode"
                )
              }
              className="btn-1 duration-200 font-semibold py-2 rounded transition w-full"
              disabled={!SelectedProducts}
            >
              Print Barcode
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BarCodeScreen;
